import { Card } from "@/components/ui/card";
import { Wind, Zap, CircleCheck, Wrench } from "lucide-react";
const services = [{
  title: "Ultraschall:",
  icon: Wind,
  features: ["Fördert die Durchblutung und unterstützt den Abtransport der gelösten Stoffe über das Lymphsystem."],
  link: "/ServiceSubpagesPage"
}, {
  title: "EMS (Elektro-Muskel-Stimulation):",
  icon: Zap,
  features: ["Anregung der körpereigenen Kollagenbildung"],
  link: "/ServiceSubpagesPage"
}, {
  title: "Gezielte Wärme:",
  icon: Wrench,
  features: ["Anregung der körpereigenen Kollagenbildung"],
  link: "/ServiceSubpagesPage"
}];
export default function OurServices() {
  return <section data-section-id="240152" id="bewei-hands" className="text-foreground py-32 px-4 relative overflow-hidden !bg-[rgba(253,245,254,1)] md:px-8">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1/2 bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-16 text-center md:text-left">
          <h2 className="font-default text-3xl font-bold tracking-tight mb-4 !text-[rgba(154,3,146,1)] md:text-5xl">So funktioniert die Technologie</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map(service => <Card key={service.title} data-index={services.indexOf(service)} className="bg-card/60 backdrop-blur-xl border-border/40 hover:border-primary/60 transition-all duration-500 overflow-hidden group shadow-xl">
              <div className="flex flex-col sm:flex-row gap-6 px-6 sm:px-8 py-8 h-full">
                <div className="shrink-0">
                  <service.icon className="size-8 text-primary shrink-0" />
                </div>
                
                <div className="flex flex-col flex-grow gap-6">
                  <div>
                    <h3 className="font-default text-2xl font-semibold tracking-tight text-foreground">{service.title}</h3>
                  </div>
                  
                  <ul className="space-y-4 text-muted-foreground flex-grow">
                    {service.features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                        <CircleCheck className="size-5 text-primary shrink-0 mt-0.5 opacity-80" />
                        <span className="leading-relaxed font-default !text-lg">{feature}</span>
                      </li>)}
                  </ul>
                  
                  
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}